import { startsWith } from 'lodash';
import type { IOrganizationWebHook } from './OrganizationWebHook.interface';

export default class OrganizationWebHook implements IOrganizationWebHook {
  url: string;
  isActive: string;

  isValid() {
    return this.isActive && startsWith(this.url.toLowerCase(), 'https://');
  }

  static build = (data: IOrganizationWebHook) => new OrganizationWebHook(data);
  static blank = () => new OrganizationWebHook();

  /**
   * Constructor
   * @param {IOrganizationWebHook} data
   */
  constructor(data?: IOrganizationWebHook) {
    this.url = data?.url || undefined;
    this.isActive = data?.isActive === true;
  }
}
